import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../Router/all_routes";
import { useState, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import TableTop from "../../Components/UI/TableTop";
import { useTableSearch } from "../../core/Operations/useTableSearch";
import { useGetEmployeeQuery } from "../../AppQuries/employee/employee_list";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  Edit,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import {
  ArrowLeft,
  Download,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Upload,
  Users,
} from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { format } from "date-fns";
import Error404 from "../ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import useTableExport from "core/Operations/useTableExport";
import { Select, Spin, Table } from "antd";
import {
  useEmployeeLoginReportQuery,
  useResetDeviceMutation,
  useUpdateEmployeeLockStatusMutation,
  useUpdateEmployeePasswordMutation,
} from "AppQuries/employee/emp-login";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import {
  useFormattedDepartmentOption,
  useFormattedEmploymentTypeOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { base_path } from "environment";
import { BackIcon } from "Components/UI/Icon/Icons";
const LoginDetails = () => {
  const userData = useSelector(loggedInUser);
  const route = all_routes;

  // const [searchParams] = useSearchParams();

  const [queryParams, setQueryParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      groupCode: params.get("groupCode") || 0,
      residentialType: params.get("residentialType") || "",
      departmentCode: params.get("departmentCode") || 0,
      gender: params.get("gender") || "",
      nationality: params.get("nationality") || "",
      employmentType: params.get("employmentType") || "",
      employeeType: params.get("employeeType") || "",
    };
  });

  const [showAll, setShowAll] = useState(false);

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);
  const employeeTypeOptions = useFormattedEmpTypeOption(userData?.companyCode);
  const { mutate: resetDevice } = useResetDeviceMutation();
  const { mutate: updateLoginPermission } =
    useUpdateEmployeeLockStatusMutation();
  const { mutate: updateEmpPassword } = useUpdateEmployeePasswordMutation();

  const {
    data: loginDetails,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getEmployees,
  } = useEmployeeLoginReportQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isAllCompanies: userData?.isAllCompanies,
    userId: userData?.userID,
    ...queryParams,
  });

  const employeeFields = loginDetails?.length
    ? Object.keys(loginDetails[0]).map((key) => ({
        title: key,
        dataIndex: key,
      }))
    : [];

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = ({ title, text }) => {
    return MySwal.fire({
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    });
  };

  const handleLoginPermission = async (record) => {
    const result = await showConfirmationAlert({
      title: "Login Permission",
      text: `Are you sure you want to ${
        record.isLock ? "unlock" : "lock"
      } login permission for this employee?`,
    });
    if (result.isConfirmed) {
      const payload = {
        companyCode: record.companyCode,
        employeeID: record.employeeCode,
        updatedUser: userData?.userName,
        updatedDate: getCurrentFormattedDate(),
        isLock: !record.isLock,
      };

      updateLoginPermission(payload, {
        onSuccess: (data) => {
          if (data?.response) {
            MySwal.fire({
              title: "Success",
              text: `Employee login permission has been ${
                record.isLock ? "unlocked" : "locked"
              } successfully.`,
              icon: "success",
            });
            const index = loginDetails.findIndex(
              (emp) => emp.employeeCode === record.employeeCode,
            );
            if (index !== -1) {
              loginDetails[index].isLock = !record.isLock;
            }
          } else {
            MySwal.fire({
              title: "Error",
              text: `Failed to update login permission: ${data?.errorMessage}`,
              icon: "error",
            });
          }
        },
        onError: (error) => {
          MySwal.fire({
            title: "Error",
            text: `Failed to update login permission: ${error.message}`,
            icon: "error",
          });
        },
      });
      // updateLoginPermission({
    } else {
      MySwal.close();
    }
  };

  const handleResetDeviceToken = async (record) => {
    const result = await showConfirmationAlert({
      title: "Reset Device",
      text: `Are you sure you want to reset device for this employee?`,
    });
    if (result.isConfirmed) {
      const payload = {
        companyCode: record.companyCode,
        employeeID: record.employeeCode,
        userName: userData?.userName,
        currentUserRole: userData?.userGroupCode,
      };

      resetDevice(payload, {
        onSuccess: (data) => {
          if (data?.response) {
            MySwal.fire({
              title: "Success",
              text: `Employee Device has been reset successfully.`,
              icon: "success",
            });
          } else {
            MySwal.fire({
              title: "Error",
              text: `Failed to update device token : ${data?.errorMessage}`,
              icon: "error",
            });
          }
        },
        onError: (error) => {
          MySwal.fire({
            title: "Error",
            text: `Failed to update login permission: ${error.message}`,
            icon: "error",
          });
        },
      });

      MySwal.fire({
        title: "Success",
        text: `Employee device has been reset successfully.`,
        icon: "success",
      });
    }
  };

  const [showPassword, setShowPassword] = useState({});

  const columns = [
    // {
    //   title: "Image",
    //   dataIndex: "employeePhotoStr",
    //   width: 100,
    //   render: (text, record) => (
    //     <div className="">
    //       {record?.employeePhotoStr === "" ||
    //       record?.employeePhotoStr === null ? (
    //         // <Link to="#" className="">
    //         <ImagePreview
    //           src={
    //             record?.gender === "M"
    //               ? base_path + "assets/img/profiles/men.png"
    //               : record?.gender === "F"
    //               ? base_path + "assets/img/profiles/women.png"
    //               : base_path + "assets/img/profiles/men.png"
    //           }
    //           alt="Employee Image"
    //         />
    //       ) : (
    //         // <ImageWithBasePath
    //         //   alt=""
    //         //   src={
    //         //     record?.gender === "M"
    //         //       ? "assets/img/profiles/men.png"
    //         //       : record?.gender === "F"
    //         //       ? "assets/img/profiles/women.png"
    //         //       : "assets/img/profiles/men.png"
    //         //   }
    //         //   width={60}
    //         // />
    //         // </Link>
    //         <ImagePreview
    //           src={record?.imageFilePath || record?.employeePhotoStr}
    //           alt={record.uniqueId}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
    { title: "Emp Code", dataIndex: "uniqueID", key: "uniqueID", width: 100 },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      key: "employeeName",
      // width: 300,

      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
          style={{ fontSize: "12px" }}
        >
          {text}
        </Link>
      ),
    },

    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
      render: (text) => <span style={{ fontSize: "12px" }}>{text}</span>,
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
      render: (text, record) => (
        <>
          <span className="me-3">
            {showPassword[record.uniqueID] ? text : "********"}
          </span>
          <button
            className="border-0"
            onClick={() =>
              setShowPassword((prev) => ({
                ...prev,
                [record.uniqueID]: !prev[record.uniqueID],
              }))
            }
          >
            {showPassword[record.uniqueID] ? (
              <EyeOff size={16} />
            ) : (
              <Eye size={16} />
            )}
          </button>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      filters: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      render: (_, record) => (
        <span
          className={
            record.isActive
              ? "badge badge-linesuccess"
              : "badge badge-linedanger"
          }
        >
          {record.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
      filters: useMemo(
        () =>
          Array.from(new Set(loginDetails?.map((d) => d.userType))).map(
            (type) => ({
              text: type,
              value: type,
            }),
          ),
        [loginDetails],
      ),
      onFilter: (value, record) => record.userType === value,
    },
    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <div className="action-set">
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
                className="dropdown-item"
                type="button"
                // onClick={() => openViewModal(record)}
              >
                <i data-feather="dollar-sign" className="info-img" />
                View Employee
              </Link>
            </li>
            <li>
              <Link
                to={`${route.employee}${route.employee_edit}/${record.employeeCode}`}
                className="dropdown-item"
                // onClick={() => openUpdateModal(record)}
              >
                <i data-feather="plus-circle" className="info-img" />
                Edit Employee
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={() => handleLoginPermission(record)}
              >
                <i data-feather="download" className="info-img" />
                Login Permission &nbsp;
                {record.isLock ? (
                  <Lock className="ms-2" size={14} />
                ) : (
                  <Unlock className="ms-2" size={14} />
                )}
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={() => handleResetDeviceToken(record)}
              >
                <i data-feather="download" className="info-img" />
                Reset Device ID
              </Link>
            </li>
            {/* <li>
                      <Link to="#" className="dropdown-item confirm-text mb-0">
                        <i data-feather="trash-2" className="info-img" />
                        Delete Sale
                      </Link>
                    </li> */}
          </ul>
        </div>
      ),
      // width: 70,
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    loginDetails,
    searchColumns,
  );

  const { onEmployeeExcelDownload } = useTableExport({
    columns: employeeFields,
    data: filteredData,
    fileName: "Employee Details",
    pdfTheme: "",
  });

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employees Login Detail</h4>
                <h6>Manage your employees login credentials</h6>
              </div>
            </div>

            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Back to employees</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.employee}${all_routes.employee_list}`}
                  className="btn btn-secondary"
                >
                  <BackIcon className="me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>

            {/* <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onEmployeeExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group d-grid">
                              <div className="form-floating">
                                <Select
                                  defaultValue={
                                    queryParams.departmentCode || ""
                                  }
                                  className="form-control"
                                  options={departmentOptions}
                                  placeholder="Department"
                                  onChange={(e) => {
                                    updateQueryParams("departmentCode", e || 0);
                                  }}
                                  onClear={() => {
                                    updateQueryParams("departmentCode", 0);
                                  }}
                                  allowClear
                                />
                                <label className="form-label">Department</label>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group d-grid">
                              <div className="form-floating">
                                <Select
                                  className="form-control"
                                  options={employeeTypeOptions}
                                  placeholder="Employee Type"
                                  // value={queryParams.employeeType || ""}
                                  onChange={(value) => {
                                    updateQueryParams(
                                      "employeeType",
                                      value || "",
                                    );
                                  }}
                                  allowClear
                                  onClear={() => {
                                    updateQueryParams("employeeType", "");
                                  }}
                                />
                                <label className="form-label">
                                  Employee Type
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={getEmployees}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                {isFetching ? (
                                  <>
                                    <i className="fas fa-spinner fa-spin me-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>Filter</>
                                )}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="total-employees d-flex mb-3 justify-content-space-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center mb-0">
                      <h6>
                        <Users className="me-2" />
                        Total Employees
                        <span>
                          {
                            filteredData?.filter((emp) =>
                              showAll ? true : emp.isActive === true,
                            )?.length
                          }
                        </span>
                      </h6>
                    </div>
                    <div className="d-flex justify-content-end align-items-center mb-0">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          checked={showAll}
                          onChange={(e) => setShowAll(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckChecked"
                        >
                          {showAll
                            ? "Showing All Employees"
                            : "Showing Active Employees"}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Spin spinning={isLoading || isFetching} size="large">
                      <Table
                        className="table  datanew"
                        columns={columns}
                        dataSource={(filteredData || []).filter((emp) =>
                          showAll ? true : emp.isActive === true,
                        )}
                        // scroll={{ x: "max-content", y: 600 }}
                        sticky={true}
                        rowKey={(record, index) => index}
                        pagination={true}
                        loading={isLoading || isFetching}
                      />
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginDetails;
